import { render, staticRenderFns } from "./Tariffversions.vue?vue&type=template&id=3bafc5d6&scoped=true&"
import script from "./Tariffversions.vue?vue&type=script&lang=js&"
export * from "./Tariffversions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bafc5d6",
  null
  
)

export default component.exports